export default "__VITE_ASSET__fb680799__"